import React, { useState } from "react";
import "./ComingSoonPage.css";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const ComingSoonPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="coming-soon-container">
      <nav className="hero-navbar">
        <img src="/images/Saffron_House.png" alt="Saffron House Logo" className="logo" />

        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </div>

        <div className={`nav-buttons ${menuOpen ? "open" : ""}`}>
          <a href="#" className="p-project-btn">Projects</a>
          <a
            className="contact-btn"
            href="https://wa.me/919977730130"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us <ArrowOutwardIcon className="icon" />
          </a>
        </div>
      </nav>

      <main className="project-hero">
        <h1 className="coming-title">Coming Soon</h1>
        <p className="coming-subtext">
          We're currently working on some beautiful spaces. Our website — including a full project showcase — is coming soon. We're just adding the final touches. Stay tuned!
          <br />
          For any queries or to learn more, feel free to <a href="https://wa.me/919977730130" target="_blank" rel="noopener noreferrer">contact us</a>.
        </p>
      </main>

      <footer className="coming-footer">
        <p>
          © 2025. All Rights Reserved.
          <br />
          Developed by{' '}
          <a href="https://arvitech.in/" target="_blank" rel="noopener noreferrer">
            ARVI Technologies And Consultation
          </a>
        </p>
      </footer>
    </div>
  );
};

export default ComingSoonPage;
